import React, { useEffect } from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import MobileBreadCrumbs from '../../Components/UIElements/Breadcrumb/MobileBreadcrumbs';
import { getCssValue } from '../../cruxComponents/utils';

const getWidth = (props) => {
  const { screenViewport, layout } = props;
  if (screenViewport === 'mobile') {
    return '90%';
  }
  if (layout !== 'double' && layout !== 'auto') {
    if (screenViewport === 'tablet') {
      return '100%';
    }
    return '80%';
  }
  return '67%';
};

const RightWrapper = styled.div`
  color: #262d3f;
  width: ${(props) => props.width || getWidth(props)};
  @media (max-width: 1024px) {
    width: ${({ width }) => width || '90%'};
  }
  margin: ${({ margin }) => margin || '20px 40px 10px'};
  max-width: ${({ maxWidth }) => maxWidth};
  @media (max-width: 980px) {
    ${({ pageId }) => pageId !== 'questions' && 'margin: 20px auto 10px;'}
    ${({ pageId }) => pageId === 'knockout' && 'height:calc(100% - 50px);'}
    ${({ pageId }) => pageId === 'challenge' && '@media(min-height:1200px){margin-top:100px}'}
  }
  @media (max-width: 480px) {
    margin: 20px auto 10px;
    width: 88%;
  }
  margin-bottom: ${({ screenViewport }) => (screenViewport === 'mobile' ? '20px' : '120px')}
    //  https://github.com/philipwalton/flexbugs/issues/157
    @media screen and (-ms-high-contrast: active) {
    margin: 10px auto 120px 0px;
  }
  @media screen and (-ms-high-contrast: none) {
    margin: 10px auto 120px 0px;
  }
`;

const Right = ({ screenViewport, content, layout, leftData, theme, pageId }) => {
  // CSS Variables
  const _maxWidth = getCssValue(theme, 'maxWidth', 'right-rightWrapper');
  const _margin = getCssValue(theme, 'margin', 'right-rightWrapper');
  const _width = getCssValue(theme, 'width', 'right-rightWrapper');

  useEffect(() => {
    const _udsHeader = document.getElementById('underwriting_decision_content');
    if (_udsHeader && _udsHeader.focus && typeof _udsHeader.focus === 'function') {
      _udsHeader.setAttribute('tabindex', '0');
      setTimeout(() => {
        _udsHeader.focus();
      }, 500);
    }
  }, [content]);

  if (screenViewport === 'mobile' && layout === 'double' && !leftData.length) {
    return (
      <MobileBreadCrumbs>
        <RightWrapper
          data-name='right'
          screenViewport={ screenViewport }
          layout={ layout }
          maxWidth={ _maxWidth }
          margin={ _margin }
          width={ _width }
          pageId={ pageId }
        >
          {content}
        </RightWrapper>
      </MobileBreadCrumbs>
    );
  }
  return (
    <RightWrapper
      data-name='right'
      screenViewport={ screenViewport }
      layout={ layout }
      maxWidth={ _maxWidth }
      margin={ _margin }
      width={ _width }
      pageId={ pageId }
    >
      {content}
    </RightWrapper>
  );
};

Right.defaultProps = {};

Right.propTypes = {
  screenViewport: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  layout: PropTypes.string.isRequired,
};

export default withTheme(Right);
